//Archivo dedicado al menu de todos los imports de COMUN

//Imports relacionados del común
//-----------Login-----------
import Login from '@/components/Login/Login.vue';

//-----------Dashboard-----------
import Plantilla from '@/components/Tablero/Plantilla.vue';
import Bienvenida from '@/components/Tablero/Bienvenida.vue';
import SistemasWeb from '@/components/Tablero/SistemasWeb.vue';
import Herramientas from '@/components/Tablero/Herramientas.vue';
import Catalogos from '@/components/Tablero/Catalogos.vue';
import APIs from '@/components/Tablero/APIs.vue';
import Escritorios from '@/components/Tablero/Escritorios.vue';
import Noticias from '@/components/Tablero/Noticias.vue';
import Usuarios from '@/components/Tablero/Usuario/Usuario.vue';

//-----------Error-------------
import Error404 from '@/components/Comunes/Error404.vue';
import Error500 from '@/components/Comunes/Error500.vue';

//Se crea la lista de paths
const Comun = [
  { path: '/Login', component: Login, meta: { tituloDeLaPagina: "Inicio de sesión", RequiereAutenticacion: false, cargaDesdeRouter: true, ValidaSesion: true, ObtenDatos: false, ObtenPermisosDelSistema: false } },
  { path: '/Tablero', component: Plantilla, meta: { tituloDeLaPagina: "Tablero", RequiereAutenticacion: true, cargaDesdeRouter: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: false },
      children: [
        { path: 'Bienvenida', component: Bienvenida, meta: { tituloDeLaPagina: "Bienvenida", RequiereAutenticacion: true, cargaDesdeRouter: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: false } },
        { path: 'SistemasWeb', component: SistemasWeb, meta: { tituloDeLaPagina: "Sistemas Web", RequiereAutenticacion: true, cargaDesdeRouter: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: false } },
        { path: 'Herramientas', component: Herramientas, meta: { tituloDeLaPagina: "Herramientas", RequiereAutenticacion: true, cargaDesdeRouter: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: false } },
        { path: 'Catalogos', component: Catalogos, meta: { tituloDeLaPagina: "Catálogos", RequiereAutenticacion: true, cargaDesdeRouter: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: false } },
        { path: 'APIs', component: APIs, meta: { tituloDeLaPagina: "API's", RequiereAutenticacion: true, cargaDesdeRouter: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: false } },
        { path: 'Escritorios', component: Escritorios, meta: { tituloDeLaPagina: "Sistemas de Escritorio", RequiereAutenticacion: true, cargaDesdeRouter: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: false } },
        { path: 'Noticias', component: Noticias, meta: { tituloDeLaPagina: "Noticias", RequiereAutenticacion: true, cargaDesdeRouter: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: false } },
        { path: 'Usuarios', component: Usuarios, meta: { tituloDeLaPagina: "Usuario", RequiereAutenticacion: true, cargaDesdeRouter: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: false } }
      ]
  },
  { path: '*', component: Error404 },
  { path: '/Error/500', component: Error500 }
];


//Se regresa la lista de paths
export default Comun;



// WEBPACK FOOTER //
// ./src/router/Comun.js